import { render, staticRenderFns } from "./NextGameStateBtn.vue?vue&type=template&id=6d0bb7cc&scoped=true&"
import script from "./NextGameStateBtn.vue?vue&type=script&lang=js&"
export * from "./NextGameStateBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0bb7cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
